buyBonusPopup = {};
buyBonusPopup.infoText = undefined;

////////////////////////////////////////////////////////
buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;

  buyBonusPopup.yesButtonNormal.enableButton(true);
  buyBonusPopup.yesButtonEnhanced.enableButton(true);
  buyBonusPopup.noButton.enableButton(true);

  const goldenBetButton = resourceManager.get('goldenBetToggleButton');
  if (goldenBetButton) {
    goldenBetButton.enterBuyABonus();
  }

  messageBus.post('game:modal', { reason: 'buy_bonus' });

  const babEnhancedStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_XTRA.coinSizes;
  const babNormalStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;

  // combine all the stakes and remove duplicates - then sort
  // this might all go wrong with stake indexes as some stakes will only be in one mode and not the other
  buyBonusPopup.allStakesCombined = babNormalStakes.concat(
    babEnhancedStakes.filter(function (el) {
      return babEnhancedStakes.indexOf(el) === -1;
    })
  );
  buyBonusPopup.allStakesCombined.sort(function (a, b) {
    return a - b;
  });

  // if the buy a bonus default stakes are different we choose the lowest of the two - game design
  const superFreeSpinsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_XTRA.defaultAmountPerLine;
  const fsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.defaultAmountPerLine;

  let defaultToUse = superFreeSpinsDefault;

  if (superFreeSpinsDefault !== fsDefault) {
    console.log('WARNING: Default buy a bonus stakes differ between modes');
    defaultToUse = Math.min(superFreeSpinsDefault, fsDefault);
  }

  // 2 next two lines are for when we want to use the default stake for the bonus buy
  // let defaultIndex = buyBonusPopup.allStakesCombined.indexOf(defaultToUse);
  // buyBonusPopup.combinedStakeIndex = defaultIndex;

  /* **************************************************************************************
   * but some games now want to go to the stake you currently have selected,
   * not the default
   * If you press the bonus buy button i'd prefer it if it inherits your
   * current bet selection, rather than revert to £1, where our base bet it higher than
   * the max bonus buy base bet it should go to the highest possible instead.
   ************************************************************************************** */
  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  const crtBaseStake = gameController.globalHelperGetStake();
  const stakeController = resourceManager.getController('stakeController');
  const numLines = stakeController.CurrentWinLineCount;
  const index = bonusBuyStakes.findIndex((stake) => stake * numLines === crtBaseStake);
  if (index !== -1) {
    buyBonusPopup.combinedStakeIndex = index;
  } else {
    buyBonusPopup.combinedStakeIndex = bonusBuyStakes.length - 1;
  }
  /* ************************************************************************************ */

  buyBonusPopup.updatePopup();

  resourceManager.getContainer('buyABonusContainer').visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

////////////////////////////////////////////////////////
// buyBonusPopup.updatePopup = function () {
//   if (buyBonusPopup.currentStakeIndex === -1) {
//     // Something went really wrong here. No compatible stakes found
//     buyBonusPopup.stakePreviousButton.enableButton(false);
//     buyBonusPopup.stakeNextButton.enableButton(false);
//     buyBonusPopup.yesButtonNormal.enableButton(false);
//     buyBonusPopup.yesButtonEnhanced.enableButton(false);
//   } else {
//     const bonusBuyStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;

//     // update the stake buttons
//     buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.currentStakeIndex > 0);
//     buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.currentStakeIndex < bonusBuyStakes.length - 1);

//     // update the base stake box
//     let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.currentStakeIndex]);
//     gameController.bonusBuyStake = baseStake;
//     buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

//     const maxBonusBuyCost = baseStake * 1000;

//     let normalCost = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostNormal;
//     buyBonusPopup.normalBetValueText.setText(gdk.formatCurrency(normalCost));
//     buyBonusPopup.yesButtonNormal.enableButton(buyBonusPopup.balance >= normalCost && normalCost <= maxBonusBuyCost);

//     let enhancedCost = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostEnhanced;
//     buyBonusPopup.enhancedBetValueText.setText(gdk.formatCurrency(enhancedCost));
//     buyBonusPopup.yesButtonEnhanced.enableButton(
//       buyBonusPopup.balance >= enhancedCost && enhancedCost <= maxBonusBuyCost
//     );
//   }
// };

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.combinedStakeIndex === -1) {
    // Something went really wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);
    buyBonusPopup.superFreespinsButton.enableButton(false);
    buyBonusPopup.freeSpinsButton.enableButton(false);
    buyBonusPopup.enableOption(buyBonusPopup.option0, false);
    buyBonusPopup.enableOption(buyBonusPopup.option1, false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.combinedStakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1);

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid for each buy a bonus mode
    const superFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_XTRA.coinSizes;
    const freeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY.coinSizes;
    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let superFreespinsStakeExists = superFreeSpinStakes.includes(stakeToFind);
    let freeSpinsStakeExists = freeSpinsStakes.includes(stakeToFind);

    // superfree spins link costs
    let costEnhanced = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostEnhanced;
    //buyBonusPopup.superFreespinsLinkCostValue.setText(gdk.formatCurrency(costEnhanced));
    const enableSuperFreeSpins = buyBonusPopup.balance >= costEnhanced && superFreespinsStakeExists;
    buyBonusPopup.enhancedBetValueText.setText(gdk.formatCurrency(costEnhanced));
    //buyBonusPopup.superFreespinsButton.enableButton(enableSuperFreeSpins);
    //buyBonusPopup.enableOption(buyBonusPopup.option1, enableSuperFreeSpins);
    buyBonusPopup.yesButtonEnhanced.enableButton(enableSuperFreeSpins);

    // Free spins costs
    let costNormal = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostNormal;
    //buyBonusPopup.freeSpinsCostValue.setText(gdk.formatCurrency(costNormal));
    const enableNormalFreeSpins = buyBonusPopup.balance >= costNormal && freeSpinsStakeExists;
    buyBonusPopup.normalBetValueText.setText(gdk.formatCurrency(costNormal));
    //buyBonusPopup.freeSpinsButton.enableButton(enableNormalFreeSpins);
    //buyBonusPopup.enableOption(buyBonusPopup.option0, enableNormalFreeSpins);
    buyBonusPopup.yesButtonNormal.enableButton(enableNormalFreeSpins);
  }
};

////////////////////////////////////////////////////////
buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

////////////////////////////////////////////////////////
buyBonusPopup.convertToTotalStake = function (coinSize) {
  let stakeController = resourceManager.getController('stakeController');
  return coinSize * stakeController.CurrentWinLineCount;
};

////////////////////////////////////////////////////////
buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play('buttonPressed');
  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(buyBonusPopup.combinedStakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

////////////////////////////////////////////////////////
buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play('buttonPressed');
  buyBonusPopup.combinedStakeIndex = Math.max(buyBonusPopup.combinedStakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

////////////////////////////////////////////////////////
buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe('spinner:GameConfigEvent', buyBonusPopup.onGameConfig);
  messageBus.subscribe('common:BalanceEvent', buyBonusPopup.onBalanceEvent);
  messageBus.subscribe('game:modal', buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

////////////////////////////////////////////////////////
buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === 'Options menu open') {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.yesButtonNormal.enableButton(false);
      buyBonusPopup.yesButtonEnhanced.enableButton(false);
      buyBonusPopup.noButton.enableButton(false);
      //buyBonusPopup.infoButton.enableButton(false);

      // update the stake buttons
      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.yesButtonNormal.enableButton(true);
      buyBonusPopup.yesButtonEnhanced.enableButton(true);
      buyBonusPopup.noButton.enableButton(true);
      //buyBonusPopup.infoButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }
  }
};

////////////////////////////////////////////////////////
buyBonusPopup.init = function () {
  buyBonusPopup.background = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground');

  buyBonusPopup.title = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:title');

  buyBonusPopup.yesButtonNormal = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:yesButtonNormal'
  );
  buyBonusPopup.yesButtonNormal.onPressedCallback = buyBonusPopup.onClickedYesNormal;

  buyBonusPopup.yesButtonEnhanced = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:yesButtonEnhanced'
  );
  buyBonusPopup.yesButtonEnhanced.onPressedCallback = buyBonusPopup.onClickedYesEnhanced;

  buyBonusPopup.noButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:noButton');
  buyBonusPopup.noButton.onPressedCallback = buyBonusPopup.onClickedNo;

  //buyBonusPopup.infoButton = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:infoButton");
  //buyBonusPopup.infoButton.onPressedCallback = buyBonusPopup.onInfo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious'
  );
  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext');
  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText'
  );

  buyBonusPopup.infoText = resourceManager.get('buyABonusContainer:buyBonusPopup:buyABonusBackground:infoText');

  buyBonusPopup.normalBetValueText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:normalBetValue'
  );
  buyBonusPopup.enhancedBetValueText = resourceManager.get(
    'buyABonusContainer:buyBonusPopup:buyABonusBackground:enhancedBetValue'
  );
};

////////////////////////////////////////////////////////
buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

////////////////////////////////////////////////////////
buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

////////////////////////////////////////////////////////
buyBonusPopup.onClosePopup = function (buyBonus, enhanced) {
  soundManager.play('buttonPressed');
  if (buyBonus) {
    buyBonusPopup.onStartBonusSpin(enhanced);
  } else {
    // Not buying a bonus, so reset
  }

  buyBonusPopup.open = false;

  let reels = resourceManager.get('slotContainer:reelContainer');
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  buyBonusPopup.callback(buyBonus);
};

////////////////////////////////////////////////////////
buyBonusPopup.onStartBonusSpin = function (enhanced) {
  let stakeController = resourceManager.getController('stakeController');

  gameController.inBuyABonusExtra = false;
  gameController.inBuyABonusNormal = false;

  if (enhanced) {
    persistence.setCurrentMode('BONUS_BUY_XTRA');
    gameController.inBuyABonusExtra = true;
  } else {
    persistence.setCurrentMode('BONUS_BUY');
    gameController.inBuyABonusNormal = true;
  }
  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  const baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);

  // Remove modal
  messageBus.post('game:modal', {});

  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  if (enhanced) {
    stakeController.requestChangeStake(baseStake, 'BONUS_BUY_XTRA');
  } else {
    stakeController.requestChangeStake(baseStake, 'BONUS_BUY');
  }

  let bpl = baseStake / stakeController.CurrentWinLineCount;

  let buyCost = 0;
  if (enhanced) {
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostEnhanced;
  } else {
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostNormal;
  }

  if (!enhanced) {
    gameController.initNewSpin();
  }
  // else if it's xtra buy bonus, then initNewSpin() gets called by 'sidewinder:XtraPowerBonusBuyStart' message
  // AFTER it transitions into "xtra power in next feature" state

  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: stakeController.CurrentWinLineCount,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
        buyABonusXtra: enhanced,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

messageBus.subscribe('sidewinder:XtraPowerBonusBuyStart', gameController.initNewSpin);

////////////////////////////////////////////////////////
buyBonusPopup.onClickedYesNormal = function () {
  buyBonusPopup.onClosePopup(true, false);
};

////////////////////////////////////////////////////////
buyBonusPopup.onClickedYesEnhanced = function () {
  buyBonusPopup.onClosePopup(true, true);
};

////////////////////////////////////////////////////////
buyBonusPopup.onClickedNo = function () {
  // Remove modal
  buyBonusPopup.open = false;

  messageBus.post('game:modal', {});
  buyBonusPopup.onClosePopup(false, false);
};

////////////////////////////////////////////////////////
buyBonusPopup.onInfo = function () {
  soundManager.play('buttonPressed');
  gameData.helpPageScroll.open();
};

buyBonusPopup.onStakeChanged = function (stake) {
  if (!buyBonusPopup.open && stake !== undefined) {
    let stakeController = resourceManager.getController('stakeController');
    if (stakeController.Stakes.indexOf(stake) !== -1) {
      // only save valid stakes
      gameController.currentNonBABStake = stake;
    }
  }
};

////////////////////////////////////////////////////////
buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

////////////////////////////////////////////////////////
resourceManager.registerObjectType(
  'buyBonusPopup',
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);

messageBus.subscribe('stake:stakeChanged', buyBonusPopup.onStakeChanged);
